import requestConfig from 'app/requests/ServiceCenter/ServiceCenter.requests'
import SkyNetDataGrid from 'app/PoC/DataGridDemoPages/components/SkyNetDataGrid'
import {
    RequestKeys,
} from 'app/hooks/useRequest'
import {
    useDataGridSource,
} from 'app/PoC/DataGridDemoPages/components/hooks'
import useStyles
    from 'app/PoC/DataGridDemoPages/ServiceCentersDemo/ServiceCentersDemoScenarioEditor/ServiceCentersDemoScenarioEditor.styles'
import useLabel from 'app/hooks/useLabel'

import columns from './OutboundOrders.columns'

const OutboundOrders = ({
    serviceCenterId,
}: Readonly<{ serviceCenterId: number }>) => {
    const l = useLabel()
    const {
        classes,
    } = useStyles()

    const dataSource = useDataGridSource({
        request: requestConfig.outboundOrders({
            serviceCenterId,
        }),
        key: RequestKeys.getOutboundOrders,
    })

    return (
        <SkyNetDataGrid
            persistentKey="demo-serviceCenterOutboundOrders-table"
            columns={columns}
            customDataSource={dataSource}
            toolbarProps={{
                title: l('OUTBOUND_ORDERS'),
            }}
            classNames={{
                container: classes.tableContainer,
                tableWrapper: classes.tableWrapper,
            }}
        />
    )
}

export default OutboundOrders
